import useCrud from 'hooks/useCrud';
import {
  fetchMarketingTask,
  createMarketingTask,
  updateMarketingTask,
  deleteMarketingTask,
} from 'services/api/oms';

function useTask() {
  return useCrud({
    read: fetchMarketingTask,
    create: createMarketingTask,
    update: updateMarketingTask,
    del: deleteMarketingTask,
  });
}

export default useTask;
